<template>
    <custom-travel />
</template>
<script>
import CustomTravel from '@/views/product/CustomTravel.vue'
export default {
    layout: 'Main',
    auth: false,
    head: {
        title: '定制游'
    },
    components: {
        CustomTravel
    }
}
</script>
<style lang="">

    

</style>